import {ComponentType, SVGProps} from "react";
import {FooterXSvg} from "@/app/components/icons/FooterXSvg";
import {InstagramSvg} from "@/app/components/icons/InstagramSvg";
import {WhatsAppSvg} from "@/app/components/icons/WhatsAppSvg";

export interface IFooterLink {
    label: string;
    href: string;
}

export interface ISocialLink extends IFooterLink {
    Icon: ComponentType<SVGProps<SVGSVGElement>>;
    /** X is shown as a square icon-only button in the design. */
    iconOnly?: boolean;
}

// Footer "Casino" block, in the design's column order (three columns of two).
export const CASINO_FOOTER_LINKS: IFooterLink[] = [
    {label: 'MenuItems.slots', href: '/casino/categories/slots'},
    {label: 'MenuItems.liveCasino', href: '/casino/categories/live-casino'},
    {label: 'MenuItems.fastGames', href: '/casino/categories/fast-games'},
    {label: 'MenuItems.providers', href: '/casino/providers'},
    {label: 'AppFooter.popularGames', href: '/casino/categories/popular'},
    {label: 'MenuItems.gameShows', href: '/casino/categories/game-shows'},
];

// WhatsApp channel per site language. Registration country is not available on the
// frontend, so the locale decides: every Spanish and Portuguese locale gets the Spanish
// channel, every other language the English one.
const WHATSAPP_CHANNEL_EN = 'https://whatsapp.com/channel/0029VbDpumoElah15zfwAI2y';
const WHATSAPP_CHANNEL_ES = 'https://whatsapp.com/channel/0029VbD1gCRISTkFc3SsjY1i';
const ES_PT_LANGUAGES = ['es', 'pt'];

export const getWhatsAppChannel = (locale: string): string =>
    ES_PT_LANGUAGES.includes(locale.split('-')[0]) ? WHATSAPP_CHANNEL_ES : WHATSAPP_CHANNEL_EN;

export const getSocialLinks = (locale: string): ISocialLink[] => [
    {label: 'Communities.x', href: 'https://x.com/Aldex_Win', Icon: FooterXSvg, iconOnly: true},
    {label: 'Communities.instagram', href: 'https://www.instagram.com/aldex.win?igsh=OGx2bzJuMXVqcWFn', Icon: InstagramSvg},
    {label: 'Communities.whatsapp', href: getWhatsAppChannel(locale), Icon: WhatsAppSvg},
];
